module.exports = __webpack_public_path__ + "img/b_shop_01_s.2c754382.jpg";